import { createContext, useContext } from "react";

/**
 * Minimize control supplied by `WindowMinimizeContext` and accepted by `WindowChromeControls`.
 * @deprecated Internal context; do not use in consumer packages. Will be removed in Q1 2027.
 * `SlottedWindow` handles minimize/collapse state automatically.
 */
export interface WindowMinimize {
    minimized: boolean;
    onToggle: () => void;
    /** True when this window is currently rendered in a dock slot. */
    isDocked: boolean;
}

export const WindowMinimizeContext = createContext<WindowMinimize | null>(null);

/**
 * @deprecated Internal hook. Use `SlottedWindow`'s built-in collapse behaviour instead.
 * Will be removed in Q1 2027.
 */
export function useWindowMinimize(): WindowMinimize | null {
    return useContext(WindowMinimizeContext);
}
